import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import HomepageHighlightedMember from './HomepageHighlightedMember'; // @ts-expect-error ts-migrate(7016) NOFIX

import avatarImage from 'bender-url!../../../../images/highlightedMembers/dharmesh-shah.png';
export default function DharmeshShah({
  avatarSize
}) {
  return /*#__PURE__*/_jsx(HomepageHighlightedMember, {
    displayName: "Dharmesh Shah",
    roleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.homepage.memberHighlight.members.dharmeshShah.role"
    }),
    avatarSrc: avatarImage,
    avatarSize: avatarSize
  });
}